export default {
  title: "مدیریت FAQ",
  addNewFaq: "افزودن سوال جدید",
  questionFa: "سوال فارسی",
  questionEn: "سوال انگلیسی",
  answerFa: "پاسخ فارسی",
  answerEn: "پاسخ انگلیسی",
};
